import { Filter } from '../../types';
import { onlyUnique } from '../../../../utils/helpers';
import { DeviceType } from '../../../Device/types';

export const filtersFromQueryString = (queryString: string) => {
  const filters: Filter[] = [];
  const pairs = queryString.substr(1).split('&');
  for (const p of pairs) {
    const pair = p.split('=');
    if (pair[0] && pair[1]) {
      let obj = {
        category: decodeURIComponent(pair[0]),
        value: decodeURIComponent(pair[1]),
      };
      if (obj.category === 'measurementType') {
        obj.value = measurementTypeSpecialQuery(obj.value);
      }

      filters.push(obj);
    }
  }
  return filters.filter(
    onlyUnique(
      (f1, f2) =>
        decodeURIComponent(f1.value) === decodeURIComponent(f2.value) &&
        f1.category === f2.category
    )
  );
};

export const queryStringFromFilters = (filters: Filter[]) => {
  if (filters.length === 0) {
    return '';
  }

  const queries: string[] = [];
  for (const f of filters) {
    let category = f.category;
    let value = f.value;
    if (f.category === 'measurementType') {
      value = measurementTypeSpecialQuery(f.value);
    }
    queries.push(
      `${encodeURIComponent(category)}=${encodeURIComponent(value)}`
    );
  }
  return `?${queries.join('&')}`;
};

export const measurementTypeSpecialQuery = (value: string) => {
  if (DeviceType.BodyComposition === value) {
    return 'Impedance';
  }
  if (value === 'Impedance') {
    return DeviceType.BodyComposition;
  }
  return value;
};
